/*
 * @Description:
 * @LastEditors: wjx
 * @Date: 2020-11-10 13:57:25
 */
import roleManagementPart from './part/roleManagement';
import subAccountLogPart from './part/subAccountLog';
import authActionPart from './part/authAction';

export const roleManagement = [
  {
    name: '角色管理',
    childMenu: [roleManagementPart]
  }
];

export const subAccountLog = [
  {
    name: '子账号操作日志',
    childMenu: [subAccountLogPart]
  }
];

export const authAction = [
  {
    name: '项目权限',
    childMenu: [authActionPart]
  }
];
